import { createSlice } from '@reduxjs/toolkit'

import { filesAdapter } from './selectors'
import { uploadFile } from './actions'
import { FileUploadState } from 'bundles/Pilot/types'

export const filesSlice = createSlice({
  name: 'files',
  initialState: filesAdapter.getInitialState(),
  reducers: {
    removeFile: filesAdapter.removeOne,
    removeAllFiles: filesAdapter.removeAll,
    updateFileProgress: (state, action) => {
      const { clientId, progress } = action.payload
      const existingFile = state.entities[clientId]
      if (existingFile) {
        existingFile.progress = progress
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(uploadFile.pending, (state, action) => {
      const file = { ...action.meta.arg }
      const contentType = file.attachment.type
      const name = file.attachment.name

      delete file.attachment
      delete file.onProgress

      const params = {
        ...file,
        contentType,
        name,
        state: FileUploadState.Uploading,
        progress: 0,
      } as any

      filesAdapter.upsertOne(state, params)
    })
    builder.addCase(uploadFile.fulfilled, (state, action) => {
      filesAdapter.upsertOne(state, {
        ...action.payload.data,
        state: FileUploadState.Uploaded,
        progress: 100,
      })
    })
    builder.addCase(uploadFile.rejected, (state, action) => {
      const file = { ...action.meta.arg }

      delete file.attachment
      delete file.onProgress

      filesAdapter.upsertOne(state, {
        ...file,
        state: FileUploadState.UploadFailed,
        uploadError: action.error.message,
        progress: 0,
      } as any)
    })
  },
})

export default filesSlice.reducer

export const { removeAllFiles, removeFile, updateFileProgress } = filesSlice.actions
